import React from 'react';
import { FiLogOut } from 'react-icons/fi';
import { SquircleBox } from '../design_system/shapes/SquircleBox';
import { useLogout } from '../components/UserMenu';
import styles from './SidebarItem.module.css';

export default function SidebarLogout({ collapsed = false }) {
  const handleLogout = useLogout();

  return (
    <div className={styles.logoutWrap}>
      <button
        type="button"
        className={[styles.link, styles.logoutLink].join(' ')}
        onClick={handleLogout}
        title="Log out"
        aria-label="Log out"
      >
        <SquircleBox shape="md" className={styles.linkShell}>
          <span
            className={[
              styles.linkContent,
              collapsed ? styles.linkContentCollapsed : '',
            ]
              .filter(Boolean)
              .join(' ')}
          >
            <span className={styles.linkIcon} aria-hidden="true">
              <FiLogOut />
            </span>
            <span
              className={[
                styles.linkLabel,
                collapsed ? styles.linkLabelCollapsed : '',
              ]
                .filter(Boolean)
                .join(' ')}
            >
              Log out
            </span>
          </span>
        </SquircleBox>
      </button>
    </div>
  );
}
